<template>
    <div class="Vehicle" style="background-color:rgb(245,245,249);">
        <Gnb v-bind:gnbCode=gnbCode v-bind:loginInfo1=loginInfo1 v-bind:loginInfo2=loginInfo2 />
        <div style="width:100%;" class="d-flex flex-row "  >
            <Navs v-bind:navCode1=navCode1 v-bind:navCode2=navCode2 v-bind:NavList=NavList />
            <div class="mt-3" style="width:100%; background-color:rgb(245,245,249);">
                <PageCrumbs v-bind:pTitles=pTitles v-bind:pCrumbs=pCrumbs />
                <div class="content" style="width:100%;min-height:770px;padding:2px 15px; background-color:rgb(245,245,249);">
                    <SummeryCnt v-bind:scnt1=scnt1 v-bind:scnt2=scnt2  v-bind:scnt3=scnt3  v-bind:scnt4=scnt4 
                    v-bind:summeryTtile=summeryTtile  v-bind:summeryTtile1=summeryTtile1  v-bind:summeryTtile2=summeryTtile2  v-bind:summeryTtile3=summeryTtile3 v-bind:summeryTtile4=summeryTtile4  />
                    <v-card elevation="1" class="mt-3" >
                        <div class="d-flex pt-3" style="width:100%;">
                            <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Registration Date</div>
                            <div class="d-flex pr-5" style="width:100%;">
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-menu 
                                        ref="menu1"
                                        v-model="menu1"
                                        :close-on-content-click="false"
                                        :return-value.sync="s_date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="150px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field 
                                            v-model="s_date"
                                            append-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            single-line hide-details outlined dense
                                            class="d-flex align-self-center mt-0 pt-0"
                                            style="font-size:13px; "
                                            placeholder="Start Date"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="s_date" no-title scrollable :max="e_date">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="s_date_search(s_date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </div>
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-menu
                                        ref="menu2"
                                        v-model="menu2"
                                        :close-on-content-click="false"
                                        :return-value.sync="e_date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="220px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                            v-model="e_date"
                                            append-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            single-line hide-details outlined dense
                                            class="align-self-center ma-0 pa-0"
                                            style="font-size:13px;width:190px;"
                                            placeholder="End Date"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="e_date" no-title scrollable :min="s_date" :max="date">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="e_date_search(e_date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </div>
                                <div class="d-flex" >
                                    <v-btn-toggle v-model="toggleMonthBtn" class="pt-4">
                                        <v-btn small class="ml-1" @click="setSchDate(1)">Today</v-btn>
                                        <v-btn small  @click="setSchDate(2)">1 Month</v-btn>
                                        <v-btn small  @click="setSchDate(3)">All</v-btn>
                                    </v-btn-toggle>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" style="width:100%;">
                            <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Classification</div>
                            <div class="d-flex pr-5" style="width:100%;">
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="schCountryCode" :items="countryList" item-text="info" item-value="vals" label="National" outlined dense single-line hide-details>
                                    </v-select>
                                </div>
                                <!--
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="schUsrClsCode" :items="usrClsList" item-text="info" item-value="vals" label="UserType" outlined dense single-line hide-details>
                                    </v-select>
                                </div>
                                -->
                                <div class="d-flex " style="width:180px;">
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="schAprvStatus" :items="statusList" item-text="info" item-value="vals" label="Status" outlined dense single-line hide-details>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" style="width:100%;">
                            <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Keyword</div>
                            <div class="d-flex" style="width:100%;">
                                <div class="d-flex pt-2 pr-auto" style="width:557px;">
                                    <v-text-field v-model="schText" outlined dense single-line hide-details small placeholder="ID, Name, Company, Vehicle"></v-text-field>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex pb-5 justify-center" style="width:100%;">
                            <v-btn class="schClearBtn" small dark @click="searchFormReset()">Clear </v-btn>
                            <v-btn class="ml-2 schBtn" small dark @click="getList()">Search</v-btn>
                        </div>
                    </v-card>
                    <v-card elevation="1" class="mt-3">
                        <div class="d-flex flat pa-5" elevation="0" >
                            <div class="mr-auto align-self-center font-weight-bold text-subtitle-1" >Total <span class="listCnt">{{listTotalCnt}}</span></div>
                            <div class="pr-2">
                                <!-- 예약상태(1:대기, 2:예약완료, 3:예약취소, 4:교환완료) -->
                                <v-btn color="red" small outlined class="ml-2" @click="setAprvStatus('D')">Disapproval</v-btn>
                                <v-btn color="teal" small  outlined class="ml-2" @click="setAprvStatus('N')">Ready</v-btn>
                                <v-btn color="indigo" small  outlined  class="ml-2" @click="setAprvStatus('Y')">Approval</v-btn>
                            </div>
                        </div>
                        <div>
                            <table style="width:100%;" cellspacing="0" cellpadding="0" class="px-5">
                                <tr class="listHeader">
                                    <th style="width:20px"><v-checkbox class="align-self-center pl-2 ma-0" hide-details color="white" dark @click="checkedAll" v-model="allSelected"></v-checkbox></th>
                                    <th style="width:20px">No</th>
                                    <th style="width:10%">National</th>
                                    <th style="width:15%">ID</th>
                                    <th style="width:15%">Name</th>
                                    <th style="width:15%">Company</th>
                                    <th style="width:15%">Vehicle Number</th>
                                    <th style="width:8%">Vaild Terms</th>
                                    <th style="width:12%">Status</th>
                                    <th style="width:12%">Registration Date</th>
                                </tr>
                                <tr v-for="(item, index) in ebikeList" :key="item.USR_ID">
                                    <td class="rowList"><v-checkbox v-model="selectEbkSeq" class="align-self-center pl-2 ma-0" hide-details  :value=item.USR_ID @click="selected()"></v-checkbox></td>
                                    <td class="rowList">{{(listTotalCnt - (page -1) * 10) - index}}</td>
                                    
                                    <td class="rowList">{{item.NAT_NAME_KR}}</td>
                                    <td class="rowList"><span style="color:#1976D2;cursor:pointer;" @click="viewInfo(item.USR_ID)">{{item.USR_ID}}</span></td>
                                    <td class="rowList">{{item.USR_NM}}</td>
                                    <td class="rowList">{{item.USR_COMPANY_NAME}}</td>
                                    <td class="rowList">{{item.VC_NUMS}}</td>
                                    <td class="rowList">
                                      
                                        <v-btn color="green" small @click="viewValidTerms(item.USR_ID,item.VALID_START_DT,item.VALID_START_HI, item.VALID_END_DT, item.VALID_END_HI)" v-if="item.VALID_START_DT != undefined && item.CLASSFICATION==2"> In operation
                                        </v-btn>

                                        <v-btn color="gray"  small @click="setVaildTerms(item.USR_ID)" v-if="item.VALID_START_DT==undefined && item.CLASSFICATION==2" > SetUp
                                        </v-btn>
                                    </td>
                                    <td class="rowList">{{item.APRV_INFO}}</td>
                                    <td class="rowList">{{item.INS_DTM}}</td>
                                </tr>
                                <tr v-if="emptyFlag=='Y'">
                                    <td colspan="10" style="height:80px;">
                                        <div>no data</div>
                                    </td>
                                </tr>
                            </table>
                            <div class="pa2" v-if="listTotalCnt>0">
                                <div class="text-center mt-5">
                                    <!--
                                    <v-pagination v-model="page" :length="pagelength" @input="getPageList"></v-pagination>
                                    -->
                                    <Paging :currentPage="page" :totalPages="pagelength"  :totalCount="listTotalCnt" @onPageChange="onPageChange" />
                                </div>
                            </div>
                            <div class="d-flex justify-space-between dense pa-5">
                                <!-- <div class="pa2 pl-2 " ><v-btn class="excelBtn" dark >Excel Download</v-btn></div> -->
                                <div class="pa2 pr-2">
                                    <!-- <v-btn color="green lighten-2" small dark class="ml-2">Excel Registration</v-btn> -->
                                    <!-- <v-btn color="primary" small dark class="ml-2" @click="registerVehicle">New Registration</v-btn> -->
                                </div>
                            </div>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
        <Footer/>

        <!-- alert: not checked -->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="chkListFlag" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:red;'>mdi-alert </v-icon>
                        <span class="pl-3">Please select a list of reserve </span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="chkListFlag = false">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        
        <!--<ErrorDialog v-on:childEvent="closeErrorDialog" />-->

        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncSuccess" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-check-circle </v-icon>
                        <span class="pl-3">It's been processed successfully</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="closeDialog('Success')">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!--asyncErrors-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncErrors" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-alert-circle </v-icon>
                        <span class="pl-3">It's been processed failed.</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="closeDialog('Error')">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="openValidTerm" width="550" height="400">
                <v-card height="400">
                    <v-card-title class="text-subtitle-1 pb-0 mb-5">
                       Setup Valid Terms 
                    </v-card-title>
                    <v-divider class="mx-4"></v-divider>
                    <v-card-text class="my-5">
                       <div>
                            <div class="d-flex pt-3 " style="width:100%;">
                                <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Start Date</div>
                                <div class="d-flex pr-5" style="width:100%;">
                                    <div class="d-flex pr-5" style="width:180px;">
                                        <v-menu 
                                                ref="menu21"
                                                v-model="menu21"
                                                :close-on-content-click="false"
                                                :return-value.sync="s_date2"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="150px">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field 
                                                    v-model="s_date2"
                                                    append-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    single-line hide-details outlined dense
                                                    class="d-flex align-self-center mt-0 pt-0"
                                                    style="font-size:13px; "
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker v-model="s_date2" no-title scrollable :max="e_date2">
                                                    <v-spacer></v-spacer>
                                                    <v-btn text color="primary" @click="menu21 = false">Cancel</v-btn>
                                                    <v-btn text color="primary" @click="s_date_search2(s_date2)">OK</v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </div>
                                        <div class="d-flex pr-5 align-center" style="width:180px;">
                                            <vue-timepicker v-model="sTime" :minute-interval="10"  close-on-complete></vue-timepicker>
                                        </div>
                                    </div>
                                </div>
                        </div>
                       <div>
                                <div class="d-flex pt-3 " style="width:100%;">
                                    <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Start Date</div>
                                    <div class="d-flex pr-5" style="width:100%;">
                                        <div class="d-flex pr-5" style="width:180px;">
                                            <v-menu
                                                ref="menu22"
                                                v-model="menu22"
                                                :close-on-content-click="false"
                                                :return-value.sync="e_date"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="220px">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                    v-model="e_date2"
                                                    append-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    single-line hide-details outlined dense
                                                    class="align-self-center ma-0 pa-0"
                                                    style="font-size:13px;width:190px;"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker v-model="e_date2" no-title scrollable :min="s_date2" >
                                                    <v-spacer></v-spacer>
                                                    <v-btn text color="primary" @click="menu22 = false">Cancel</v-btn>
                                                    <v-btn text color="primary" @click="e_date_search2(e_date2)">OK</v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </div>
                                        <div class="d-flex pr-5 align-center" style="width:180px;">
                                            <vue-timepicker v-model="eTime" :minute-interval="10" close-on-complete ></vue-timepicker>
                                            
                                        </div>
                                    </div>
                                </div>
                           </div>
                    </v-card-text>
                    <v-divider class="mx-4"></v-divider>
                    <v-card-actions class="justify-end mt-10">
                        <v-btn color="gray" outlined text @click="closeDialog('ValidTerms')">Cancel</v-btn>
                        <v-btn color="primary" outlined text @click="regValidTerms()">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="openValidTerm2" width="550" height="400">
                <v-card height="400">
                    <v-card-title class="text-subtitle-1 pb-0 mb-5">
                       Setup Valid Terms 
                    </v-card-title>
                    <v-divider class="mx-4"></v-divider>
                    <v-card-text class="my-5">
                       <div>
                            <div class="d-flex pt-3 " style="width:100%;">
                                <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Start Date</div>
                                <div class="d-flex pr-5" style="width:100%;">
                                    <div class="d-flex pr-5" style="width:180px;">
                                        <v-menu 
                                                ref="menu21"
                                                v-model="menu21"
                                                :close-on-content-click="false"
                                                :return-value.sync="s_date2"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="150px" disabled>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field 
                                                    v-model="s_date2"
                                                    append-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    single-line hide-details outlined dense
                                                    class="d-flex align-self-center mt-0 pt-0"
                                                    style="font-size:13px; "
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker v-model="s_date2" no-title scrollable :max="e_date2">
                                                    <v-spacer></v-spacer>
                                                    <v-btn text color="primary" @click="menu21 = false">Cancel</v-btn>
                                                    <v-btn text color="primary" @click="s_date_search2(s_date2)">OK</v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </div>
                                        <div class="d-flex pr-5 align-center" style="width:180px;">
                                            <vue-timepicker v-model="sTime" :minute-interval="10"  close-on-complete disabled></vue-timepicker>
                                        </div>
                                    </div>
                                </div>
                        </div>
                       <div>
                                <div class="d-flex pt-3 " style="width:100%;">
                                    <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Start Date</div>
                                    <div class="d-flex pr-5" style="width:100%;">
                                        <div class="d-flex pr-5" style="width:180px;">
                                            <v-menu
                                                ref="menu22"
                                                v-model="menu22"
                                                :close-on-content-click="false"
                                                :return-value.sync="e_date"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="220px" disabled>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                    v-model="e_date2"
                                                    append-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    single-line hide-details outlined dense
                                                    class="align-self-center ma-0 pa-0"
                                                    style="font-size:13px;width:190px;"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker v-model="e_date2" no-title scrollable :min="s_date2" >
                                                    <v-spacer></v-spacer>
                                                    <v-btn text color="primary" @click="menu22 = false">Cancel</v-btn>
                                                    <v-btn text color="primary" @click="e_date_search2(e_date2)">OK</v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </div>
                                        <div class="d-flex pr-5 align-center" style="width:180px;">
                                            <vue-timepicker v-model="eTime" :minute-interval="10" close-on-complete disabled></vue-timepicker>
                                            
                                        </div>
                                    </div>
                                </div>
                           </div>
                    </v-card-text>
                    <v-divider class="mx-4"></v-divider>
                    <v-card-actions class="justify-end mt-10">
                        <v-btn color="gray" outlined text @click="closeDialog('ValidTerms2')">Close</v-btn>
                        <v-btn color="primary" outlined text @click="setVaildTerms(vUsrID)">Edit</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!-- Alert Dialog / Save -->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="alertFlag" width="450">
                <v-card>
                    <v-card-title class="text-subtitle-2 pb-0 text-wrap d-flex flat" style="width:450px;">
                        <v-icon class='d-flex' style='color:red;'>mdi-alert </v-icon>
                        <span class="d-flex pl-3">{{alertText}}</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="alertFlag = false;regFlag='Y'">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

    </div>
</template>

<style scoped>
    th {height:38px;}
    .rowList { padding:5px 0;}
    /*.theme--light.v-btn.v-btn--has-bg {background-color: #1e2c3c !important; color:#fff}*/
    @import '~vue2-timepicker/dist/VueTimepicker.css';

    .dropdown drop-down {height:50px !important;}
    .display-time {height:40px !important;}
</style>

<script>
import Gnb from '@/components/gnbComponent.vue'
import PageCrumbs from '@/components/pageCrumbs.vue'
import SummeryCnt from '@/components/summeryCnt.vue'
import Footer from '@/components/footerComponent.vue'
import Navs from '@/components/nav.vue'
import Paging from '@/components/paging.vue'

// CommonJS
import VueTimepicker from 'vue2-timepicker/dist/VueTimepicker.common.js'


export default {
    name: 'MemberApproval',
    components: {
        Gnb, Footer, SummeryCnt, Navs,
        PageCrumbs, VueTimepicker, Paging
    },

    data () {
        return {
            // login Info
            gnbCode:"5", loginInfo1: "", loginInfo2: "", loginInfo3: "",
            navCode1:2, navCode2:21, 
            // Page Title & Breadcrumbs
            pTitles: "Approve List ",
            pCrumbs: [ { text: 'Home', disabled: true,}, { text: 'Member', disabled: true,}, { text: 'Approve Management', disabled: true,}, { text: 'Approve List', disabled: false,}],
            NavList: [ 
                        {  title: 'Member Management', nums: '1',
                            items: [ { title: 'Member List', nums:11, href:'/Member', icons:'mdi-format-list-bulleted' }],
                        },
                        { title: 'Approve Management', nums: '2',
                            items: [ { title: 'Approve List', nums:21, href:'/MemberApproval', icons:'mdi-format-list-bulleted' }],
                        },
                    ],     

            // Summery title & Count
            scnt1:"0", scnt2:"0", scnt3:"0", scnt4:"0", summeryTtile:"등록현황", summeryTtile1:"Total", summeryTtile2:"Approval", summeryTtile3:"Ready", summeryTtile4:"disapproval",
            // List count & Pagination 
            listTotalCnt: 0, page: 0, pagelength:0, ebikeList:[],
            emptyFlag: 'Y',
            // Datepicker & Short button
            date: new Date().toISOString().substr(0, 10), 
            s_date: "", e_date: "", menu1: false, menu2: false,
            s_date2: "", e_date2: "", menu21: false, menu22: false,
            sTime:"", eTime:"",
            toggleMonthBtn:2,

            // Search form : select 
            countryList: [{info: 'Indonesia', vals: "ID"}, {info: 'korea', vals: "KR"}],
            statusList:[{info: '승인반려', vals: 'D'}, {info: '승인대기', vals: 'N'}, {info: '승인완료', vals: 'Y'}],
            usrClsList:[{info: 'B2C', vals: 1}, {info: 'B2B', vals: "2"}],
            schCountryCode: "", schText:"", schUsrClsCode:"", schAprvStatus:"",
            
            // Checkbox
            selectEbkSeq:[], allSelected: false,
            // Async & Modify Result
            chkListFlag : false,  asyncErrors: false, asyncSuccess: false, openValidTerm:false, openValidTerm2: false,

            vUsrID:"", alertText:"", regFlag:"Y",  alertFlag:false,
        } 
    },
   
    beforeCreate() {
        let uuid = localStorage.getItem("e3MngID");
        let uauthcode = localStorage.getItem("e3MngCode"); 
        if(uuid != '' && uauthcode !='') {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
            };
            fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                if(json.result != "success") {
                    this.$router.replace('RequireLogin');
                } 
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        } else {
             this.$router.replace('RequireLogin');
        }
    },

    created() {
        this.loginInfo1=localStorage.getItem("e3MngID");
        this.loginInfo2=localStorage.getItem("e3MnglgDTM");
        this.loginInfo3=localStorage.getItem("e3MngCode");
        this.page = 1;
        this.getList(this.page);
        localStorage.removeItem("modUsrID");
    },

    methods : {
        // datepicker 
        setSchDate(arg) {
            if(arg == 1) {
                this.s_date = new Date().toISOString().substr(0, 10);
                this.e_date = new Date().toISOString().substr(0, 10);
            } else if(arg == 2) {
                let now = new Date();
                this.s_date =  new Date(now.setMonth(now.getMonth() - 1));
                this.s_date = this.s_date.toISOString().substr(0, 10);
                this.e_date = new Date().toISOString().substr(0, 10);
            } else if(arg == 3) {
                this.s_date = '';
                this.e_date = '';
            }
        },

        // datepicker - sub
        s_date_search(v) {
            this.s_date = v;
            this.menu1 = false;
            this.$refs.menu1.save(v);
        },

        // datepicker - sub
        e_date_search(v) {
            this.e_date = v;
            this.menu2 = false;
            this.$refs.menu2.save(v);
        },

        // datepicker - sub
        s_date_search2(v) {
            this.s_date2 = v;
            this.menu21 = false;
            this.$refs.menu21.save(v);
        },

        // datepicker - sub
        e_date_search2(v) {
            this.e_date2 = v;
            this.menu22 = false;
            this.$refs.menu22.save(v);
        },

        // search form reset
        searchFormReset() {
            this.s_date=""; this.e_date="";
            this.schCountryCode=""; this.schUsrClsCode=""; this.schAprvStatus=""; this.schText="";
        },

        getPageList() {
            //console.log(this.page);
            this.getList(this.page);
        },

        // API Async 
        getList(page) {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "L"
                    , "page":page
                    , "schAprvStatus": this.schAprvStatus
                    , "schCountryCode": this.schCountryCode
                    , "schUsrClsCode": this.schUsrClsCode
                    , "schStartDate": this.s_date, "schEndDate": this.e_date
                    , "schText": this.schText 
                })
            };
            //console.log(requestOptions.body);
            
            fetch('https://api.e3bss.com/_APP/POC/memberApproval.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json );
                //console.log(json.value.list );
                if(json.result == "success") {
                    this.ebikeList =[];
                    this.ebikeList = json.value.list;
                    this.listTotalCnt = Number(json.totalCnt);
                    this.pagelength = json.totalPage;
                    this.emptyFlag = "N";
                    this.page = json.currentPage;
                } else {
                    this.ebikeList = [];
                    this.emptyFlag = "Y";
                    this.listTotalCnt = 0;
                }
                this.scnt1 = json.cnt1; this.scnt2 = json.cnt2; this.scnt3 = json.cnt3; this.scnt4 = json.cnt4;
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },

        // Approve Status Modify
        setAprvStatus(vals) {
            //console.log(this.selectEbkSeq.length + "/"+ this.selectEbkSeq);
            if(vals != '' && this.selectEbkSeq.length > 0) {
                this.chkListFlag = false;
                this.modifyApprove(vals);
            } else {
                this.chkListFlag = true;
            }
        },

        // API Async: Status Update
        modifyApprove(arg) {
            var requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "LU"
                    , "modUsrIDArr": this.selectEbkSeq
                    , "modeUSrStatus": arg
                })
            };
            /*
            console.log(JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "LU"
                    , "modUsrIDArr": this.selectEbkSeq
                    , "modeUSrStatus": arg
                }));
            */
            fetch('https://api.e3bss.com/_APP/POC/memberApproval.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json);
                if(json.result == "success") {
                    this.getList(1);
                    this.asyncSuccess = true;
                    this.asyncErrors = false;
                } else {
                    this.asyncSuccess = false;
                    this.asyncErrors = true;
                }
            }).catch(() => {
                this.asyncErrors = true;
                //console.log(error);
            });
        }, 
        
        viewInfo(arg) {
            //console.log(arg);
            localStorage.setItem("modUsrID", arg);
            this.$router.push({ name: 'MemberDetail', params: { modUsrID: arg }})
        },

        checkedAll() {
            //console.log('click');
            this.selectEbkSeq = [];

            if (this.allSelected) {
                for (let ebkies in this.ebikeList) {
                    this.selectEbkSeq.push(this.ebikeList[ebkies].RSV_SEQ.toString());
                }
            }
        },

        selected: function() {
            this.allSelected = false;
        }, 
        
        closeDialog(cls) {
            if(cls == "Success") {
                this.asyncSuccess = false;
            } else if(cls == "Error") {
                this.asyncErrors = false;
            } else if(cls == "ValidTerms") {
                this.openValidTerm = false;
            } else if(cls == "ValidTerms2") {
                this.openValidTerm2 = false;
            }
            
            this.selectEbkSeq = [];
            this.allSelected=false;
            this.vUsrID=""; this.s_date2=''; this.e_date2='';
            this.sTime="", this.eTime=""; this.menu21=false, this.menu22=false;
        },
        
        alertToForm(arg1, arg2) {
            var str1 = "enter";
            var strInfo1 = "Please"; var strInfo2 = "information";
            if(arg1 == 2) str1 = 'select';
            this.alertText = strInfo1 +' '+ str1 +' '+ arg2 +' '+ strInfo2+".";
            // Please select country information 
        },

        viewValidTerms(uid,sd,sh,ed,eh) {
            if(uid!=''&&sd!=''&&sh!=''&&ed!=''&&eh!='') {
                this.vUsrID=uid;
                this.s_date2=sd;
                this.sTime=sh;
                this.e_date2=ed;
                this.eTime=eh;
                this.openValidTerm2=true;
            }
        },

        setVaildTerms(uid) {
            this.openValidTerm2=false;
            //console.log('v-uid'+uid);
            this.openValidTerm=true;
            this.vUsrID=uid;
        }, 

        regValidTerms() {
             if(this.sTime == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Start Time');
                return;
            }
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "VU"
                    , "vUsrID": this.vUsrID
                    , "sDate": this.s_date2, "sTime": this.sTime
                    , "eDate": this.e_date2, "eTime": this.eTime
                })
            };
            /*
            console.log(JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "VU"
                    , "vUsrID": this.vUsrID
                    , "sDate": this.s_date2, "sTime": this.sTime
                    , "eDate": this.e_date2, "eTime": this.eTime
                }));
            */
            fetch('https://api.e3bss.com/_APP/POC/memberApproval.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json);
                if(json.result == "success") {
                    this.getList(this.page);
                    this.asyncSuccess = true;
                    this.asyncErrors = false;
                    this.closeDialog('ValidTerms');
                } else {
                    this.asyncSuccess = false;
                    this.asyncErrors = true;
                }
            }).catch(() => {
                this.asyncErrors = true;
                //console.log(error);
            });
        },

        onPageChange(param) {
            //console.log("onPageChange="+param);
            this.page = Number(param);
            //console.log("this.page="+Number(this.page));
            this.getList(this.page);
        }

    }

}
</script>
